<infigo-detail-block>
	<app-skeleton [height]="'200px'" [loading]="loading">
		<n-tab
            [(activeItem)]="defaultActiveItem"
            [type]="'card'"
            style="height: calc(100% - 0.33rem)"
        >
            <n-tab-item [header]="firstTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-file-share-table #fileShareTable [checkOnlyShowFsShare]="checkOnlyShow" [dtreeData]="dtreeParams" [fsData]="fileSystemData" [shareType]="'NFS'" [updateLoading]="updateLoading"></app-file-share-table>
                            <n-checkbox (onChange)="onOnlyShowFsChange()" [(ngModel)]="checkOnlyShow" [label]="i18n.get('service.fileSystem_term_view_fsOwnShares_checkbox')"></n-checkbox>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
            <n-tab-item [header]="secondTabItem" *ngIf="!ProductConfig.isHideCifs">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-file-share-table #fileShareTable [checkOnlyShowFsShare]="checkOnlyShow" [dtreeData]="dtreeParams" [fsData]="fileSystemData" [shareType]="'CIFS'" [updateLoading]="updateLoading"></app-file-share-table>
                            <n-checkbox (onChange)="onOnlyShowFsChange()" [(ngModel)]="checkOnlyShow" [label]="i18n.get('service.fileSystem_term_view_fsOwnShares_checkbox')"></n-checkbox>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
            <n-tab-item [header]="thirdTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-file-quota-table #quotaTable [checkOnlyShowFsQuota]="checkOnlyShow" [dtreeData]="dtreeParams" [fsData]="fileSystemData" [loading]="updateLoading">
                            </app-file-quota-table>
                            <n-checkbox (onChange)="onOnlyShowFsChange()" [(ngModel)]="checkOnlyShow" [label]="i18n.get('service.fileSystem_term_view_fsOwnQuotas_checkbox')"></n-checkbox>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
            <n-tab-item [header]="fourthTabItem" *ngIf="!ProductConfig.isHideDtree">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-member-dtree-table #dtreeTable [data]="dtreeData" [loading]="updateLoading"></app-member-dtree-table>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
		</n-tab>
	</app-skeleton>
</infigo-detail-block>
